import React from "react";
import DeviceBasedRenderer from "../../../../components/common/DeviceBasedRenderer";
import OrganismDisplayViewInfoMealPreviewDesktop from "./OrganismDisplayViewInfoMealPreviewDesktop";
import OrganismDisplayViewInfoMealPreviewMobile from "./OrganismDisplayViewInfoMealPreviewMobile";

const OrganismDisplayViewInfoMealPreview = (props) => {
  console.log(
    "🎯 기기별 밀 미리보기 라우터 - OrganismDisplayViewInfoMealPreview"
  );

  return (
    <DeviceBasedRenderer
      DesktopComponent={OrganismDisplayViewInfoMealPreviewDesktop}
      MobileComponent={OrganismDisplayViewInfoMealPreviewMobile}
      AndroidComponent={OrganismDisplayViewInfoMealPreviewMobile} // 안드로이드도 모바일 컴포넌트 사용
      IOSComponent={OrganismDisplayViewInfoMealPreviewMobile} // iOS도 모바일 컴포넌트 사용
      {...props} // 모든 props를 하위 컴포넌트에 전달
    />
  );
};

export default OrganismDisplayViewInfoMealPreview;
